import {
    CustomSeriesPricePlotValues,
    ICustomSeriesPaneView,
    PaneRendererCustomData,
    WhitespaceData
} from 'lightweight-charts'
import { defaultOptions, PlusIconSeriesOptions } from './options'
import { PlusIconSeriesRenderer } from './plusIconRenderer'
import { PlusIconData } from './data'

export class PlusIconSeries<TData extends PlusIconData>
    implements ICustomSeriesPaneView<number, TData> {
    _renderer: PlusIconSeriesRenderer<TData>

    constructor() {
        this._renderer = new PlusIconSeriesRenderer()
    }

    priceValueBuilder(plotRow: TData): CustomSeriesPricePlotValues {
        return [
            0,
            ...plotRow.values
        ]
    }

    isWhitespace(data: TData | WhitespaceData<number>): data is WhitespaceData<number> {
        return !Boolean((data as Partial<TData>).values?.length)
    }

    renderer(): PlusIconSeriesRenderer<TData> {
        return this._renderer
    }

    update(
        data: PaneRendererCustomData<number, TData>,
        options: PlusIconSeriesOptions
    ): void {
        this._renderer.update(data, options)
    }

    defaultOptions() {
        return defaultOptions
    }
}
